/* ============================================================================
  cart-drawer.js
  <cart-drawer> カスタム要素の実装（Dawn標準相当）。

  このファイルが無かったため、snippets/cart-drawer.liquid のHTMLは
  存在していても、開閉・自動更新などの機能が一切動作していなかった。
  （global.js には menu-drawer や header-drawer 等は定義されているが、
    cart-drawer だけが定義されていなかった）

  trapFocus / removeTrapFocus / onKeyUpEscape は global.js 側の
  共通関数を利用する（既存のため、ここでは定義しない）。
============================================================================ */

if (!customElements.get('cart-drawer')) {
  customElements.define(
    'cart-drawer',
    class CartDrawer extends HTMLElement {
      constructor() {
        super();

        this.addEventListener('keyup', (event) => {
          if (event.code === 'Escape') this.close();
        });

        const overlay = this.querySelector('#CartDrawer-Overlay');
        if (overlay) overlay.addEventListener('click', this.close.bind(this));

        this.setHeaderCartIconAccessibility();
      }

      setHeaderCartIconAccessibility() {
        // カート追加時はドロワーを開くが、ヘッダーのカートアイコンを
        // クリックした時はカートページへ通常通り遷移させたいため、
        // ここでのクリック横取り（ドロワーを開く処理）はあえて行わない。
      }

      open(triggeredBy) {
        if (triggeredBy) this.setActiveElement(triggeredBy);

        // アニメーションが発火しないことがあるための保険（1フレーム遅らせる）
        setTimeout(() => {
          this.classList.add('animate', 'active');
        });

        document.body.classList.add('overflow-hidden');

        this.addEventListener(
          'transitionend',
          () => {
            const containerToTrapFocusOn = this.classList.contains('is-empty')
              ? this.querySelector('.drawer__inner-empty')
              : document.getElementById('CartDrawer');
            const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
            if (containerToTrapFocusOn && typeof trapFocus === 'function') {
              trapFocus(containerToTrapFocusOn, focusElement);
            }
          },
          { once: true }
        );
      }

      close() {
        this.classList.remove('active', 'animate');
        if (typeof removeTrapFocus === 'function') removeTrapFocus(this.activeElement);
        document.body.classList.remove('overflow-hidden');
      }

      setActiveElement(element) {
        this.activeElement = element;
      }

      // カートが更新された際（商品追加・数量変更など）に、
      // AJAXで取得したセクションHTMLでドロワーの中身を差し替える。
      renderContents(parsedState) {
        this.getSectionsToRender().forEach((section) => {
          const sectionElement = section.selector
            ? document.querySelector(section.selector)
            : document.getElementById(section.id);

          if (!sectionElement || !parsedState.sections || !parsedState.sections[section.id]) return;

          sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
        });

        // 中身の更新後、実際に「空カート表示」が含まれているかどうかで、
        // 外側の <cart-drawer> 自身の is-empty クラスも更新する。
        // これが無いと、表示・非表示を切り替えるCSS（cart-drawer.is-empty ...）が
        // 古い状態のまま判定されてしまい、空カート時に何も表示されなくなる。
        const isEmptyNow = !!this.querySelector('.drawer__inner-empty');
        this.classList.toggle('is-empty', isEmptyNow);

        const cartItemsEl = this.querySelector('cart-drawer-items');
        if (cartItemsEl) cartItemsEl.classList.toggle('is-empty', isEmptyNow);

        setTimeout(() => {
          const overlay = this.querySelector('#CartDrawer-Overlay');
          if (overlay) overlay.addEventListener('click', this.close.bind(this));

          // カートページ自体にいる時は、同じ内容（梱包カード等）が
          // サイドバーに既に表示されているため、ドロワーは自動で開かない。
          const cartUrl = window.routes && window.routes.cart_url;
          const onCartPage = cartUrl
            ? window.location.pathname === cartUrl
            : /\/cart(\/|$)/.test(window.location.pathname);
          if (!onCartPage) this.open();
        });
      }

      getSectionInnerHTML(html, selector = '.shopify-section') {
        return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
      }

      getSectionsToRender() {
        return [
          {
            id: 'cart-drawer',
            selector: '#CartDrawer',
            section: 'cart-drawer',
          },
          {
            id: 'cart-icon-bubble',
          },
        ];
      }
    }
  );
}